import { ArrowDownUp, GitMerge, Percent } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Card, CardContent } from '@/components/ui/card';

interface StrategyCard {
	key: string;
	title: string;
	description: string;
}

const CARDS: Record<string, StrategyCard> = {
	fallback: {
		key: 'fallback',
		title: 'Fallback Chain',
		description:
			'Ordered priority list of connections. On failure, automatically routes to the next connector in the chain.',
	},
	weighted: {
		key: 'weighted',
		title: 'Weighted Split',
		description:
			'Distribute traffic across connections by percentage using weighted random selection on every send.',
	},
	volcap: {
		key: 'volcap',
		title: 'Volume Cap Overflow',
		description:
			'Route to a primary connection until the daily cap is hit, then automatically overflow to a backup.',
	},
};

const ICONS: Record<string, React.ReactNode> = {
	fallback: <ArrowDownUp className="h-5 w-5" />,
	weighted: <Percent className="h-5 w-5" />,
	volcap: <GitMerge className="h-5 w-5" />,
};

interface RoutingCardsProps {
	onSetup: (card: StrategyCard) => void;
}

export function RoutingCards({ onSetup }: RoutingCardsProps) {
	return (
		<div className="grid grid-cols-3 gap-4">
			{Object.values(CARDS).map((card) => (
				<Card key={card.key} className="border">
					<CardContent className="flex flex-col gap-3 p-5">
						<div className="text-muted-foreground">{ICONS[card.key]}</div>
						<h3 className="font-semibold">{card.title}</h3>
						<p className="text-sm text-muted-foreground">{card.description}</p>
						<Button
							variant="outline"
							size="sm"
							className="self-start"
							onClick={() => onSetup(card)}
						>
							Setup
						</Button>
					</CardContent>
				</Card>
			))}
		</div>
	);
}
